import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-toke-redirect',
  imports: [],
  templateUrl: './toke-redirect.component.html',
  styleUrl: './toke-redirect.component.css'
})
export class TokeRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);


  ngOnInit() {
    const token = this.route.snapshot.paramMap.get('token');
    if (token) {
      localStorage.setItem('jwt', token);
      this.router.navigate(['/']); // Redirect to default route
    }
  }
}
